import styles from './menuWrapper.scss';
import { ReactNode } from 'react';

export interface MenuWrapperAttributes {
  children: ReactNode;
}
export const MenuWrapper = ({ children }: MenuWrapperAttributes) => (
  <div className={styles.menuWrapper}>{children}</div>
);
